import { SubscriptionSummary, MixSummary } from 'ggApp/types/graphql';

import ActionsTypes from './actionTypes';

import { Action } from './actions';

export type SummaryState = {
    mixSummary: MixSummary | null;
    subscriptionSummary: SubscriptionSummary[];
};

export const defaultState: SummaryState = {
    mixSummary: null,
    subscriptionSummary: [],
};

function reducer(state: SummaryState = defaultState, action: Action): SummaryState {
    if (action.type === ActionsTypes.SET_SUBSCRIPTION_SUMMARY) {
        return {
            ...state,
            subscriptionSummary: action.payload,
        };
    }

    if (action.type === ActionsTypes.SET_MIX_SUMMARY) {
        return {
            ...state,
            mixSummary: action.payload,
        };
    }

    return state;
}

export default reducer;
